import React from "react";
import HeaderComponent from "./components/Header";

const Header = (props) => <HeaderComponent {...props} />;

export default Header;
